import styled, {css} from 'styled-components';
import InsightsHeroShape from '../Images/InsightsHeroShape.png';
import AssistHeroBgSmall from './AssistHeroBg2.png';
import AssistHeroBgBig from './AssistBgBig.png';
import InsightsBgSmall from './InsightsBgSmall.png';
import TestimonialsBg from './TestimonialsBg.svg';

import {getColors, maxMediaQueries, mediaQueries} from '../../utils/styling';

const Section = styled('section')`
    width: 100%;
    position: relative;
    margin: ${({margin}) => margin ? '128px 0' : 'initial'};

    /* TODO: Move these hero-specific styles */
    ${({assistHero}) =>
    assistHero &&
    css`
        ${maxMediaQueries.lg`
          background-image: url(${AssistHeroBgSmall});
        `};

        ${mediaQueries.lg`
          background-image: url(${AssistHeroBgBig});
          background-image: cover;
        `};

        /*background-size: 150% 100%;*/        
        
      `}

    ${({insightsHero, reviewHero}) =>
    (insightsHero || reviewHero) &&
    css`
        background-image: url(${InsightsHeroShape});
        background-size: 50%;
        background-position: top left;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 100px; /* removes bottom overlapping with next section */
        ${maxMediaQueries.lg`
          min-height: 0;
          margin-bottom: 0;
          background-image: url(${InsightsBgSmall});
          background-size: 100%;
        `}
      `}
    
    ${props =>
    props.customerLogos &&
    `padding: 0; background-color: ${getColors(props.theme).grey3}`}
    ${props =>
    props.intro &&
    css`
        padding: 60px 0;
        p {
          margin-top: 20px;
        }
        button {
          margin-top: 20px;
        }
        ${maxMediaQueries.lg`
          height: auto;
          padding: 30px 0;
        `}
      `}
    

      // TODO [redesign] remove?
      ${({testimonials}) =>
    testimonials &&
    css`
          position: relative;
          min-height: 420px;
          padding: 40px 0;
          background-image: url(${TestimonialsBg});
          background-size: 700px;
          background-position: -50px -50px;
          background-repeat: no-repeat;
          
          &:before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;                        
            background-image: url(${TestimonialsBg});
            background-size: 700px;
            background-position: -50px -50px;
            background-repeat: no-repeat;
            transform: scale(-1, -1);
          }
                
          ${maxMediaQueries.lg`
            background-size: 600px;
            &:before { display: none;}
          `};
        `}
      
        ${({assisttestmonials}) =>
    assisttestmonials &&
    css`
            ${maxMediaQueries.lg`
              margin: 60px 0;
            `}
            ${maxMediaQueries.sm`
                margin: 0px;
            `};

          `}
        
        ${({insightsTestimonial}) =>
    insightsTestimonial &&
    css`
            ${maxMediaQueries.lg`
              padding: 80px 20px;
            `}
          `}
      
    ${({color, theme}) =>
    color &&
    css`
        background-color: ${color === 'yellow' ?
        getColors(theme).yellow :
        (color === 'pink' ?
            getColors(theme).pink1 :
            (color === 'blue' ? getColors(theme).blue : getColors(theme).green))}
      `}
   
    ${props =>
    props.features &&
    css`
        height: 220px;
        div {
          width: 84%;
          margin: auto;

        }
        h2 {
          margin: auto;
          display: block;
        }
        ${maxMediaQueries.lg`
          height: auto;
          padding: 30px 0;
          div {
            width: 100%;
          }
        `}
      `}
    ${props =>
    props.grey && `background-color: ${getColors(props.theme).grey3};`}
    ${props =>
    props.cta &&
    css`
        & > div {
          height: 100%;
        }
        background-image: url(${props.src});
        background-size: cover;
        background-position: center;
        height: 558px;
        button {
          width: 200px;
          margin: 20px auto;
        }
      `}
    ${props =>
    props.benefits &&
    css`
        ${mediaQueries.lg`
          padding-top: ${props.insights ? '50px' : '150px'};
        `};

        ${maxMediaQueries.sm`
          padding-top: '50px';
          padding-bottom: 60px;
        `};

        p {
          width: 430px;
          line-height: 32px;
          padding: 15px 0;
          font-size: 16px;
        }
        h4 {
          font-weight: 400;
          padding: 15px 0;
        }
        ${maxMediaQueries.lg`
          p {
            width: 100%;
          }
        `}
      `}
`;

export default Section;
